import { MouseEvent, ButtonHTMLAttributes, forwardRef } from 'react'

export type AtomButtonProps = {
  type: 'submit' | 'reset' | 'button'
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean
} & ButtonHTMLAttributes<HTMLButtonElement>

export const AtomButton = forwardRef<HTMLButtonElement, AtomButtonProps>(
  (
    { type = 'button', onClick, children, ...attrs }: AtomButtonProps,
    forwardedRef,
  ) => {
    return (
      <button type={type} onClick={onClick} ref={forwardedRef} {...attrs}>
        {children}
      </button>
    )
  },
)
